import { directorLiveScores } from "./directorLiveModel";

export function directorResultsReview(match, scores, participants = []) {
  const scoring = directorLiveScores(match, scores, participants);
  if (!scoring) return null;
  if (match.family === "arc") {
    const unknownStages = Math.max(0, scoring.expectedStages - scoring.stages.length);
    return { ...scoring, kind: "cards", total: scoring.received, approved: scoring.confirmed,
      review: scoring.received - scoring.confirmed, empty: scoring.stages.filter(stage => !stage.received).length,
      detailsAvailable: scoring.stages.length > 0, unknownStages,
      sections: scoring.stages.map(stage => ({ key: stage.id, title: stage.label, total: stage.received, approved: stage.confirmed,
        review: stage.received - stage.confirmed, empty: stage.received === 0 ? 1 : 0 })) };
  }
  // Rollup "official" can describe a partial Bullseye aggregate. Inspect actual
  // units; never infer a full program or match-wide finalization from that label.
  const aggregates = scores.matchRows?.length ? scores.matchRows : (scores.results || []).filter(row => row.discipline === "bullseye");
  const groups = new Map();
  let incompleteDetails = false;
  aggregates.forEach(row => {
    if (!row.firearms?.length) incompleteDetails = true;
    (row.firearms || []).forEach(group => {
      const key = group.gunGroupId;
      if (!key) { incompleteDetails = true; return; }
      if (!groups.has(key)) groups.set(key, { key, title: group.firearmTitle || "Scoring group", total: 0, approved: 0, review: 0, empty: 0, refire: 0, unknown: 0 });
      const result = groups.get(key);
      const units = (group.courses || []).flatMap(course => course.scoreUnits || []);
      if (!units.length) incompleteDetails = true;
      units.forEach(unit => {
        result.total += 1;
        if (unit.status === "official") result.approved += 1;
        else if (unit.status === "unscored") result.empty += 1;
        else if (unit.status === "needs_refire") result.refire += 1;
        else if (["in_progress", "scored", "audited"].includes(unit.status)) result.review += 1;
        else result.unknown += 1;
      });
    });
  });
  const sections = [...groups.values()];
  const sum = key => sections.reduce((total, section) => total + section[key], 0);
  return { ...scoring, kind: "units", sections, total: sum("total"), approved: sum("approved"), review: sum("review"),
    empty: sum("empty"), refire: sum("refire"), unknown: sum("unknown"),
    detailsAvailable: sections.length > 0 && !incompleteDetails, unknownStages: 0 };
}
